import { DateObject } from 'react-multi-date-picker';
import { StatisticsVariant } from '../types/statistic-variant';
import {
  endOfDay,
  endOfMonth,
  min,
  startOfDay,
  startOfMonth,
  subDays,
} from 'date-fns';

export const monthMap = {
  '01': 'jan',
  '02': 'feb',
  '03': 'mar',
  '04': 'apr',
  '05': 'may',
  '06': 'jun',
  '07': 'jul',
  '08': 'aug',
  '09': 'sep',
  '10': 'oct',
  '11': 'nov',
  '12': 'dec',
};

export function getStatisticsDateRangeIso(
  range: DateObject[] | null,
  variant: StatisticsVariant,
): {
  from: string | null;
  to: string | null;
} {
  if (
    !range ||
    range.length < 2 ||
    !(range[0] instanceof DateObject && range[0].isValid) ||
    !(range[1] instanceof DateObject && range[1].isValid)
  ) {
    return { from: null, to: null };
  }

  let fromDate: Date;
  let toDate: Date;

  if (variant === 'DAILY') {
    fromDate = new Date(
      Date.UTC(range[0].year, range[0].month.index, range[0].day),
    );
    toDate = new Date(
      Date.UTC(
        range[1].year,
        range[1].month.index,
        range[1].day,
        23,
        59,
        59,
        999,
      ),
    );
  } else {
    const localStartOfMonth = startOfMonth(range[0].toDate());
    const localEndOfMonth = endOfMonth(range[1].toDate());

    fromDate = new Date(
      Date.UTC(
        localStartOfMonth.getFullYear(),
        localStartOfMonth.getMonth(),
        localStartOfMonth.getDate(),
      ),
    );
    toDate = new Date(
      Date.UTC(
        localEndOfMonth.getFullYear(),
        localEndOfMonth.getMonth(),
        localEndOfMonth.getDate(),
        23,
        59,
        59,
        999,
      ),
    );
  }

  return {
    from: fromDate.toISOString(),
    to: toDate.toISOString(),
  };
}

export const getMinMaxCalendarDates = (
  variant: StatisticsVariant,
  range: DateObject[] | null,
) => {
  const now = new Date();
  let minDate: Date;
  let maxDate: Date;

  switch (variant) {
    case 'DAILY': {
      minDate = startOfDay(subDays(now, 30));
      maxDate = endOfDay(now);
      return { minDate, maxDate };
    }
    default: {
      const currentMonthEnd = endOfMonth(now);
      if (
        range &&
        range.length === 1 &&
        range[0] instanceof DateObject &&
        range[0].isValid
      ) {
        const selected = range[0] as DateObject;

        minDate = startOfMonth(
          new Date(selected.year, selected.month.index - 1),
        );
        const basicMaxDate = endOfMonth(
          new Date(selected.year, selected.month.index + 1),
        );

        maxDate = min([basicMaxDate, currentMonthEnd]);

        return {
          minDate,
          maxDate,
        };
      }
      return { minDate: undefined, maxDate: currentMonthEnd };
    }
  }
};
